(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arcania-statementv2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var selector = '[data-arcania-statement]';
    var observers = new Map();

    function rootsWithin(scope) {
      var roots = [];
      if (!scope) return roots;
      if (scope.nodeType === 1 && scope.matches && scope.matches(selector)) roots.push(scope);
      if (scope.querySelectorAll) {
        Array.prototype.forEach.call(scope.querySelectorAll(selector), function (root) {
          roots.push(root);
        });
      }
      return roots;
    }

    function splitGraphemes(text) {
      if (window.Intl && Intl.Segmenter) {
        var segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
        return Array.from(segmenter.segment(text), function (part) { return part.segment; });
      }
      return Array.from(text);
    }

    function containsCjk(text) {
      return /[\u3040-\u30ff\u3400-\u9fff\uf900-\ufaff]/.test(text);
    }

    function setTimings(root, lastStart, mult) {
      var ruleDelay = (lastStart + 0.45) * mult;
      var jpDelay = (lastStart + 0.90) * mult;
      root.style.setProperty('--rule-delay', ruleDelay.toFixed(3) + 's');
      root.style.setProperty('--rule-ignite', (ruleDelay + 0.5 * mult).toFixed(3) + 's');
      root.style.setProperty('--jp-delay', jpDelay.toFixed(3) + 's');
    }

    function appendAnimatedText(lineEl, text, state) {
      var parts = text.match(/\s+|[^\s]+/g) || [];

      parts.forEach(function (part) {
        if (/^\s+$/.test(part)) {
          lineEl.appendChild(document.createTextNode(' '));
          var spaces = splitGraphemes(part).length;
          if (spaces) {
            state.lastStart = state.cStart + state.cStep * (state.idx + spaces - 1);
            state.idx += spaces;
          }
          return;
        }

        var target = lineEl;
        if (!containsCjk(part)) {
          var wordEl = document.createElement('span');
          wordEl.className = 'arcania-statement__word';
          lineEl.appendChild(wordEl);
          target = wordEl;
        }

        splitGraphemes(part).forEach(function (ch) {
          var fadeD = (state.cStart + state.cStep * state.idx) * state.mult;
          state.lastStart = state.cStart + state.cStep * state.idx;
          state.idx += 1;

          var outer = document.createElement('span');
          outer.className = 'arcania-statement__ch';
          outer.style.setProperty('--d', fadeD.toFixed(3) + 's');
          outer.style.setProperty('--dur', (state.cDur * state.mult).toFixed(3) + 's');

          var inner = document.createElement('span');
          inner.className = 'arcania-statement__ink';
          inner.style.setProperty('--d', (fadeD + 0.1 * state.mult).toFixed(3) + 's');
          inner.textContent = ch;

          outer.appendChild(inner);
          target.appendChild(outer);
        });
      });
    }

    function init(root) {
      if (!root || root.getAttribute('data-arcania-initialized') === 'true') return;
      root.setAttribute('data-arcania-initialized', 'true');
      root.classList.add('js');

      var speed = root.getAttribute('data-speed') || 'normal';
      var mult = speed === 'slow' ? 1.3 : (speed === 'fast' ? 0.72 : 1);
      var quoteEl = root.querySelector('.arcania-statement__quote');
      var animateQuote = root.classList.contains('fx-chars') || root.classList.contains('fx-shimmer');
      var state = { cStart: 0.2, cStep: 0.072, cDur: 1.2, idx: 0, lastStart: 0, mult: mult };

      /* 引用文が空でも、罫線と日本語のdelay変数を必ず定義する */
      setTimings(root, 0, mult);

      if (quoteEl && animateQuote) {
        var segments = quoteEl.innerHTML.split(/<br[^>]*>/i);
        var accessibleLines = [];
        quoteEl.innerHTML = '';

        segments.forEach(function (segment) {
          var tmp = document.createElement('div');
          tmp.innerHTML = segment;
          var text = tmp.textContent || '';
          accessibleLines.push(text);

          var lineEl = document.createElement('span');
          lineEl.className = 'arcania-statement__line';
          lineEl.setAttribute('aria-hidden', 'true');
          appendAnimatedText(lineEl, text, state);
          quoteEl.appendChild(lineEl);
        });

        var srText = accessibleLines.join(' ').replace(/\s+/g, ' ').trim();
        if (srText) {
          var srOnly = document.createElement('span');
          srOnly.className = 'arcania-statement__sr-only';
          srOnly.textContent = srText;
          quoteEl.appendChild(srOnly);
        }

        setTimings(root, state.lastStart, mult);
      }

      function reveal() {
        root.classList.add('is-in');
        var currentObserver = observers.get(root.id);
        if (currentObserver) {
          currentObserver.disconnect();
          observers.delete(root.id);
        }
      }

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        reveal();
        return;
      }

      if (!('IntersectionObserver' in window)) {
        reveal();
        return;
      }

      var previousObserver = observers.get(root.id);
      if (previousObserver) previousObserver.disconnect();

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) reveal();
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

      observers.set(root.id, observer);
      observer.observe(root);
    }

    function initWithin(scope) {
      rootsWithin(scope).forEach(init);
    }

    function destroyWithin(scope) {
      rootsWithin(scope).forEach(function (root) {
        var observer = observers.get(root.id);
        if (observer) observer.disconnect();
        observers.delete(root.id);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initWithin(document); }, { once: true });
    } else {
      initWithin(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initWithin(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      destroyWithin(event.target);
    });
    document.addEventListener('shopify:section:select', function (event) {
      rootsWithin(event.target).forEach(function (root) { root.classList.add('is-in'); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
